import {api} from '~/OneStepCreateInvitation/api/api';

export const eventApi = api.injectEndpoints({
  endpoints: (builder) => ({
    saveEventDraft: builder.mutation({
      query(body) {
        return {
          url: body.event.id ? `/event/${body.event.id}/update/` : `/event/create/`,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: (result, error, event) => [{type: 'Event', id: event.eventId}],
    }),
    sendEvent: builder.mutation({
      query: (eventId) => ({
        url: `/send/${eventId}`,
        method: 'POST',
      }),
    }),
  }),
});

export const {useSaveEventDraftMutation, useSendEventMutation} = eventApi;
